import React from "react";

const Education = ({educationRef}) => {
    return(
        <div ref={educationRef} className="md:mt-20 md:p-0 Education p-[20px] mt-0">
            <p className="md:text-6xl font-bold text-4xl">Education<span className="text-[#ffd739]">_</span></p>
            <div className="mt-4">
                <p className="md:text-2xl font-semibold text-xl">Bachelor of Science in Information Technology</p>
                <p className="md:text-xl text-lg">Negros Oriental State University</p>
                <p className="md:text-xl text-lg">2014 - 2018</p>
            </div>

            <div className="mt-4">
                <p className="md:text-2xl font-semibold text-xl">High School</p>
                <p className="md:text-xl text-lg">Tanjay National High School</p>
                <p className="md:text-xl text-lg">2010 - 2014</p>
            </div>
        </div>
    )
}

export default Education;